<script>
import MultiSelect from 'primevue/multiselect';
import CommonService from '../../services/common';

export default {
    components: {  MultiSelect },
    props: ['field', 'value', 'disabled', 'api', 'format', 'sortField', 'name', 'localized', 'changeFn', 'disableStore', 'staticOptions'],
    data(){
        return {
           options: null
        }
    },
    mounted(){
        this.loadOptions();
    },
    computed: {
        
    },
    methods: {
        loadOptions(){
            if(!this.options){

                let params = {};
                if(this.sortField){
                    params = {
                        sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                    };
                }
                if(this.queryField){
                    params = { ...params, ...this.queryField };
                }
                

                CommonService.loadGeneric(this.api, params, response => {
                    if(response.success){
                        this.options = [];
                        this.options.push(...response.data);
                    }
                });
                // let params = {}
                // if(this.sortField){
                //     params = {
                //         sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                //     };
                // }

                // let payload = {
                //     params: params,
                //     name: this.name,
                //     api: this.api
                // };
                // this.$store.dispatch("masterData/loadData", payload);
            }
        },
        onChange(e){
            if(this.changeFn){
                let p = this.options.filter((el) => {
                    return el.value == e.value;
                });
                this.changeFn(p[0])
            }

        }
    }
}


</script>


<template>
    <MultiSelect :options="options" :optionLabel="format.label" :optionValue="format.value" display="chip" :disabled="this.disabled" :showClear="true">
        <template #value="slotProps">
            <div v-for="option of slotProps.label" :key="option">
                <span>{{$t(option)}}</span>
            </div>
        </template>
        <!-- <template #option="slotProps">
            <div>
                <span>{{$t(slotProps.option.label)}}</span>
            </div>
        </template> -->
    </MultiSelect>
</template>